import { ReactNode } from "react";

import { EmptystateStacksColored } from "components/icons/generated";
import MissingDataBanner from "components/MissingDataBanner";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import Link from "ds/components/Link";
import TextEllipsis from "ds/components/TextEllipsis";
import TileContent from "ds/components/Tile/Content";
import TileWrapper from "ds/components/Tile/Wrapper";
import Typography from "ds/components/Typography";
import { getStackVendorSettingsUrl } from "shared/Stack/OpenTofuMigration/helpers";

import DashboardWidgetsOpenTofuMigrationListSkeleton from "./ListSkeleton";

type DashboardWidgetsOpenTofuMigrationStackListProps = {
  title: string;
  action?: ReactNode;
  badge?: ReactNode;
  stacks: Array<{ id: string; name: string }>;
  isLoading: boolean;
  hasError: boolean;
  errorText: string;
  emptyTitle: string;
  emptyCaption: string;
  onRefetch: () => void;
};

const DashboardWidgetsOpenTofuMigrationStackList = ({
  title,
  action,
  badge,
  stacks,
  isLoading,
  hasError,
  errorText,
  emptyTitle,
  emptyCaption,
  onRefetch,
}: DashboardWidgetsOpenTofuMigrationStackListProps) => (
  <Box direction="column" gap="large" fullWidth>
    <Box justify="between" align="center" gap="large" fullWidth>
      <Typography tag="span" variant="p-t6">
        {title}
      </Typography>
      {action}
    </Box>

    {hasError && <MissingDataBanner text={errorText} refreshHandler={onRefetch} fullWidth />}

    {!hasError && (
      <Box direction="column" gap="medium" fullWidth>
        {isLoading && <DashboardWidgetsOpenTofuMigrationListSkeleton />}

        {!isLoading &&
          stacks.map(({ id, name }) => (
            <TileWrapper key={id}>
              <TileContent direction="row" justify="between" align="center" gap="large">
                <TextEllipsis tooltip={name}>
                  {(props) => (
                    <Link variant="secondary" href={getStackVendorSettingsUrl(id)} {...props}>
                      {name}
                    </Link>
                  )}
                </TextEllipsis>
                {badge}
              </TileContent>
            </TileWrapper>
          ))}

        {!isLoading && stacks.length === 0 && (
          <TileWrapper justify="center">
            <EmptyState title={emptyTitle} caption={emptyCaption} icon={EmptystateStacksColored} />
          </TileWrapper>
        )}
      </Box>
    )}
  </Box>
);

export default DashboardWidgetsOpenTofuMigrationStackList;
